import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import { surrealRecordSchema } from "./surreal-record";
import { getTenantSchemaAdditionalFields, tenantSchema } from "./tenant";

export const subletSchema = surrealRecordSchema.extend({
  tenants: z.lazy(() => z.array(tenantSchema)),
  fromDate: z.coerce.date(),
  toDate: z.coerce.date().optional(),
  customName: z.string().optional(),
  additionalData: additionalDataSchema,
});

export type Sublet = z.infer<typeof subletSchema>;

export function getSubletSchemaAdditionalFields(additionalFields: {
  sublet: typeof additionalDataSchema;
  person: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
}): typeof subletSchema {
  return subletSchema.extend({
    tenants: z.lazy(() =>
      z.array(getTenantSchemaAdditionalFields(additionalFields)),
    ),
    additionalData: additionalFields.sublet,
  });
}
